export default "__VITE_ASSET__e638459c__"